import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import VenueSnapshotReport from "./VenueSnapshotReport";
import VenueNewsFeed from "./VenueNewsFeed";
import VenueDashboardCalendar from "./VenueDashboardCalendar";
import SiteVisitsDash from "./SiteVisitsDash";
import { hotelGroupCanViewCalendar } from "../../../modules/permissions";
import { getNewsletterSettings } from "../../../services/newsletterSettingsService";
import { refreshUser } from "../../../modules/auth-thunks";
import { isGroupUser, token, user } from "../../../modules/auth";
import { listFormatter, nameFormatter } from "../../../utils";
import VenueDashboardNavigation from "./VenueDashboardNavigation";
import VenueReviewPackagesAlert from "../VenueReviewPackagesAlert";
import VenueUpgradeBanner from "../VenueUpgradeBanner";

const VenueNotifications = () => {
  return (
    <>
      <VenueReviewPackagesAlert />
      <VenueUpgradeBanner />
    </>
  );
};

const GridBlockComponent = ({
  title,
  children,
  id,
  fullWidth = false,
  links = null,
}) => {
  return (
    <div id={id} className={`w-full px-2 mb-4 ${fullWidth ? "" : "xl:w-1/2"}`}>
      <div className="p-4 bg-white rounded h-full">
        <div className="flex">
          {title && <h2 className="text-2xl font-bold">{title}</h2>}
          {links && <div className="ml-auto">{links}</div>}
        </div>
        {children}
      </div>
    </div>
  );
};

function VenueDashboard({ token, user, hotelGroups }) {
  const [newsletterTitle, setNewsletterTitle] = useState();
  const [newsletterLink, setNewsletterLink] = useState();
  const [newsletterPanelTitle, setNewsletterPanelTitle] = useState();

  useEffect(() => {
    let isMounted = true;
    const fetchSettings = async () => {
      const { result } = await getNewsletterSettings(token);

      if (!isMounted || !result) return;
      const agencyNewsletterTitle = result.find(
        value => value.key === "agency_newsletter_title"
      );
      const agencyNewsletterLink = result.find(
        value => value.key === "agency_newsletter_link"
      );
      if (agencyNewsletterTitle) {
        setNewsletterTitle(agencyNewsletterTitle.value);
        setNewsletterPanelTitle(agencyNewsletterTitle.label);
      }
      if (agencyNewsletterLink) {
        setNewsletterLink(agencyNewsletterLink.value);
      }
    };

    void refreshUser(true);
    void fetchSettings();

    return () => {
      isMounted = false;
    };
  }, [token]);

  return (
    <div
      className="m-0 xxl:p-16 p-4 md:p-8 venue-admin__dashboard__hero"
      style={{
        backgroundImage: "url(/img/corp-edge-reports-bg-blue-darker.jpg)",
        backgroundPosition: "0 -80px",
        width: "100vw",
        position: "relative",
        left: "50%",
        right: "50%",
        marginLeft: "-50vw",
        marginRight: "-50vw",
      }}
    >
      <div className="container">
        {hotelGroups && hotelGroups?.length > 1 ? (
          <div className={"bg-blue-light p-2 my-4"}>
            Group(s):
            <> {listFormatter.format(hotelGroups?.map(group => group.name))}</>
          </div>
        ) : null}

        <h1 className={"text-5xl text-white"}>
          Hello {user ? nameFormatter(user, false) : "User"}
        </h1>

        <VenueNotifications />

        <VenueDashboardNavigation
          newsletterTitle={newsletterTitle}
          newsletterLink={newsletterLink}
          newsletterPanelTitle={newsletterPanelTitle}
        />

        <div className="flex flex-wrap flex-row -mx-2 mt-8">
          <GridBlockComponent>
            <VenueSnapshotReport />
          </GridBlockComponent>

          <GridBlockComponent title={"Events Calendar - Confirmed Bookings"}>
            <VenueDashboardCalendar />
          </GridBlockComponent>

          <GridBlockComponent title={"News"}>
            <VenueNewsFeed
              newsletterTitle={newsletterTitle}
              newsletterLink={newsletterLink}
              newsletterPanelTitle={newsletterPanelTitle}
            />
          </GridBlockComponent>

          <GridBlockComponent title={"Latest Site Visits"}>
            <SiteVisitsDash />
          </GridBlockComponent>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    user: user(state),
    hotelGroups: user(state)?.hotelGroups || [],
    token: token(state),
    canViewCalendar: hotelGroupCanViewCalendar(state.hotelGroup),
    isGroupUser: isGroupUser(state),
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(VenueDashboard);
